import styled from "styled-components";

export const StyledTwoFaWrapper = styled.form`
  .twofa-field-group {
    margin-bottom: 25px;
    display: grid;
    grid-template-columns: 1fr;
    &__input input {
      font-weight: 700;
      text-align: center;
      letter-spacing: 5px;
    }
  }
  .twofa-action {
    display: flex;
    justify-content: center;
  }
`;